import React, { memo, useState, useCallback, useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
// import { useTranslation } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import AddIcon from '@material-ui/icons/Add'
import { useQuery, useMutation } from '@apollo/react-hooks'
import Fab from '@material-ui/core/Fab'
import { useParams } from 'react-router-dom'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { useTranslation } from 'react-i18next'

import styles from './styles'
import Address from './addressCard'
import { CompanyOffices, RoLocations, ChangeCompanyHq } from 'store'

const useStyles = makeStyles(styles)

const CompanyBusinessView: React.FunctionComponent<any> = () => {
	const params: any = useParams()
	const classes = useStyles()
	const { t } = useTranslation()
	let [newOffices, setNewOffices] = useState<number>(0)
	const [hqId, setHqId] = useState()
	const handleSetNewOffices = useCallback(
		(increment: boolean) => {
			if (increment) setNewOffices(newOffices + 1)
			else setNewOffices(newOffices - 1)
		},
		[newOffices],
	)
	const [handleChangeCompanyHqMutation] = useMutation(ChangeCompanyHq)

	const deleteEmptyOfficeAddress = useCallback(() => {
		handleSetNewOffices(false)
	}, [handleSetNewOffices])

	const { data: regions }: any = useQuery(RoLocations, {
		variables: {
			data: {
				type_in: ['Judeţe', 'National capital'],
			},
		},
	})

	const { data: companyOfficesData }: any = useQuery(CompanyOffices, {
		variables: {
			companySlug: params.companySlug,
		},
		fetchPolicy: 'cache-first',
	})
	const currentHq = useMemo(() => {
		if (
			companyOfficesData &&
			companyOfficesData.companyOffices.length > 0
		) {
			let headquarters = companyOfficesData.companyOffices.find(
				(item: any) => {
					return item.hq
				},
			)
			return headquarters.id
		} else {
			return ''
		}
	}, [companyOfficesData])

	const createNewOfficesCard = useCallback(() => {
		let result = []
		for (let i = 1; i <= newOffices; i++) {
			result.push(
				<Address
					key={`new_address_${i}`}
					deleteEmptyOfficeAddress={deleteEmptyOfficeAddress}
					regions={regions}
				/>,
			)
		}
		return result
	}, [newOffices, deleteEmptyOfficeAddress, regions])

	const handleChangeCompanyHq = useCallback(
		(event: React.ChangeEvent<{ value: any }>) => {
			if (companyOfficesData.companyOffices.length > 1) {
				setHqId(event.target.value)
				handleChangeCompanyHqMutation({
					variables: {
						id: event.target.value,
						companySlug: params.companySlug,
					},
				})
			}
		},
		[handleChangeCompanyHqMutation, params, companyOfficesData],
	)

	return (
		<Grid
			className={classes.companyBusinessRoot}
			container={true}
			direction="column"
			spacing={2}
		>
			{currentHq && (
				<Grid item xs={12}>
					<FormControl className={classes.formControl}>
						<InputLabel id="demo-simple-select-helper-label">
							{t('Headquarters')}
						</InputLabel>
						<Select
							labelId="demo-simple-select-helper-label"
							id="demo-simple-select-helper"
							value={hqId ? hqId : currentHq}
							onChange={handleChangeCompanyHq}
							name="headquarters"
						>
							{companyOfficesData &&
								companyOfficesData.companyOffices.map(
									(item: any, index: number) => {
										// build the address
										let selectedLocation = `${item.location.region2}, ${item.location.name}`

										let displayedAddress = `${
											item.address
												? item.address + ', '
												: ''
										} ${
											item.zipCode
												? item.zipCode + ', '
												: ''
										} 
									${selectedLocation}`
										return (
											<MenuItem
												key={`locations_${index}`}
												value={item.id}
											>
												{displayedAddress}
											</MenuItem>
										)
									},
								)}
						</Select>
					</FormControl>
				</Grid>
			)}

			{companyOfficesData &&
				companyOfficesData.companyOffices.map(
					(item: any, index: any) => {
						return (
							<Address
								key={`address_${index}`}
								companyOffice={item}
								deleteEmptyOfficeAddress={
									deleteEmptyOfficeAddress
								}
								regions={regions}
							/>
						)
					},
				)}
			{newOffices > 0 ? createNewOfficesCard() : undefined}

			{newOffices === 0 && (
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						paddingRight: '8px',
					}}
				>
					<Fab
						onClick={() => handleSetNewOffices(true)}
						variant="extended"
						size="medium"
						color="primary"
						aria-label="Add"
						style={{ width: '10px' }}
					>
						<AddIcon />
					</Fab>
				</div>
			)}
		</Grid>
	)
}

const CompanyBusiness = memo(props => <CompanyBusinessView {...props} />)

export default CompanyBusiness
